import { useQuery } from "@tanstack/react-query";
import userService from "../api/userService";

export const useUser = (userId) => {
  const { getUser } = userService();

  return useQuery({
    queryKey: ["get-user", userId],
    queryFn: async () => {
      const res = await getUser(userId);
      return res.data;
    },
    enabled: !!userId,
  });
};

export const useUsers = () => {
  const { getUsers } = userService();

  return useQuery({
    queryKey: ["get-users"],
    queryFn: async () => {
      const res = await getUsers();
      return res.data;
    },
  });
};
